import React, { useEffect, useState } from "react";
import { Button, Input, Modal } from "antd";
import { SaveOutlined } from "@ant-design/icons";

interface SaveTemplateModalProps {
  show: boolean;
  loading: boolean;
  onHide: () => void;
  onSave: (name: string, description: string) => void;
}

export const SaveTemplateModal: React.FC<SaveTemplateModalProps> = ({
  show,
  loading,
  onHide,
  onSave,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (show) {
      setName("");
      setDescription("");
    }
  }, [show]);

  return (
    <Modal
      open={show}
      onCancel={onHide}
      footer={null}
      zIndex={1001}
      width="100%"
      style={{ top: 0, maxWidth: "100vw", paddingBottom: 0 }}
      styles={{
        content: {
          minHeight: "100vh",
          borderRadius: 0,
          padding: 0,
          display: "flex",
          flexDirection: "column",
        },
        header: {
          padding: "16px 24px",
          margin: 0,
          borderBottom: "1px solid #eef2f7",
        },
        body: {
          flex: 1,
          overflowY: "auto",
          padding: 24,
          background: "#f8fafc",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        },
        mask: { background: "rgba(15,23,42,0.55)" },
      }}
      title={
        <div className="d-flex align-items-center gap-3">
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: 10,
              background: "#2563eb1f",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#2563eb",
              fontSize: 19,
            }}
          >
            <i className="ti ti-bookmark" />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: 16, color: "#0f172a" }}>
              Save as Template
            </div>
            <div style={{ fontSize: 12.5, color: "#94a3b8", fontWeight: 400 }}>
              Reuse this configuration later to prefill the report.
            </div>
          </div>
        </div>
      }
    >
      <div
        style={{
          width: "100%",
          maxWidth: 600,
          background: "#fff",
          border: "1px solid #e2e8f0",
          borderRadius: 12,
          padding: 24,
          marginTop: 24,
        }}
      >
        <div className="mb-3">
          <div className="mb-1" style={{ fontWeight: 500, color: "#0f172a" }}>
            Template name <span style={{ color: "#ef4444" }}>*</span>
          </div>
          <Input
            size="large"
            value={name}
            maxLength={150}
            placeholder="e.g. Saturday off — IT dept"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <div className="mb-1" style={{ fontWeight: 500, color: "#0f172a" }}>
            Description (optional)
          </div>
          <Input.TextArea
            value={description}
            maxLength={500}
            rows={4}
            placeholder="What this template configures"
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div className="d-flex justify-content-end gap-2">
          <Button onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            loading={loading}
            disabled={!name.trim() || loading}
            onClick={() => onSave(name.trim(), description.trim())}
          >
            Save Template
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SaveTemplateModal;
